import React, { createContext, useState } from "react";
import { getCookie } from "../../common/utils/cookiesHandler";

// The context now provides both the user and a setter function
export const UserContext = createContext({
  user: null,
  setUser: () => {},
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Load saved user from cookies
    const storedUser = getCookie("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
